import React from "react";
import Image from "next/image";
import GoogleLogo from "@/public/images/icons/google_logo.svg";

function GoogleIcon(props) {
  return <Image src={GoogleLogo} alt="Google" width={24} height={24} {...props} />;
}

export default React.memo(GoogleIcon);
